<script setup lang="ts">
import { ref } from 'vue';

import { GrammarText } from '@nora-monorepo/grammar-ui';
import type { UserResultDTO } from '@nora-monorepo/nora-api-client';
import { formatName } from '@nora-monorepo/shared';

import UserDetails from '#ui-shared/components/user-details/UserDetails.vue';

interface UserNameProps {
  user: UserResultDTO;
}

defineProps<UserNameProps>();

const userNameRef = ref<HTMLElement | null>(null);
</script>

<template>
  <span ref="userNameRef">
    <GrammarText :text="formatName(user) ?? ''" />
    <UserDetails
      v-if="userNameRef"
      :trigger-element="userNameRef"
      :user="user"
    />
  </span>
</template>
